var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M750.933 1046.756c-17.067 0-34.133-5.689-45.511-22.756l-455.111-455.111c-28.444-28.444-28.444-68.267 0-96.711l455.111-455.111c28.444-28.444 68.267-28.444 96.711 0s28.444 68.267 0 96.711l-409.6 409.6 409.6 409.6c28.444 28.444 28.444 68.267 0 96.711-17.067 11.378-34.133 17.067-51.2 17.067z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.11674a8449d668b6261e9fd7e18a2b41.svg";
export { ForwardRef as ReactComponent };